import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

import 'Container/GestionContrat/FichePersonne/FichePersonne.scss';
import SecondaryNavBar from 'Components/SecondaryNavBar/SecondaryNavBar';
import LoadingOverlay from 'Components/LoadingOverlay/LoadingOverlay';
import { getRechercheDetailPersonne, rechercheInfosRegimeObligatoire } from "../../../api/recherchePersonneService";
import { useDispatch, useSelector } from "react-redux";
import {
    updateContrat,
    updateDetailPersonne,
    updateInfosRegimeObligatoire
} from "../../../Redux/gestionContrat/gestionContratReducer";
import { envoiTrace } from "../../../api/techniqueEdclService";
// import MessageInfoEnvoi from "../../../Components/Formulaire/MessageInfoEnvoi/MessageInfoEnvoi";
import { emptyObject } from "../../../utils/formUtils";
import { isIndemnisationsAuthorized } from "../../../utils/metierUtils";
import { getDigit } from "../../../utils/stringUtils";
import MessageInfoEnvoi from "../../../Components/Formulaire/MessageInfoEnvoi/MessageInfoEnvoi";

export default function FichePersonne(props) {

    const navigate = useNavigate();
    const dispatch = useDispatch()

    const {
        keycloakReduce,
        infosCorrespondant,
        detailPersonne,
        InfosRegimeObligatoire,
        idPersGrc,
    } = useSelector(state => ({
        ...state.gestionContratReducer,
        ...state.keycloakReducer,
    }))

    const CONF = window?.confPub;
    const UI = CONF?.UI?.RECHERCHE_PERSONNE;
    const INPUTS = UI?.INPUTS;
    const ROUTES = CONF?.ROUTES;
    const PAGES = ROUTES?.PAGES

    const [disabledPage, setDisablePage] = useState(false);
    const [horsZone, setHorsZone] = useState(false);

    useEffect( () => {

        const fetchDetailPersonne = async () => {
            try {

                setDisablePage(true);

                const resDetailPersonne = await getRechercheDetailPersonne(idPersGrc)

                console.log("###############################")
                console.log("resDetailPersonne")
                console.log(resDetailPersonne)
                console.log("minoration")

                dispatch(updateDetailPersonne(resDetailPersonne))

                const { idPersInfinite, dateAdhesion, rangBeneficiaire } = resDetailPersonne
                const { numeroContrat } = resDetailPersonne?.contrat?.[0]

                if (numeroContrat && idPersInfinite && dateAdhesion && rangBeneficiaire) {
                    const resInfosRegimeObligatoire = await rechercheInfosRegimeObligatoire(numeroContrat, idPersInfinite, dateAdhesion, rangBeneficiaire)

                    console.log("resInfosRegimeObligatoire")
                    console.log(resInfosRegimeObligatoire)

                    dispatch(updateInfosRegimeObligatoire(resInfosRegimeObligatoire))
                }

            } catch (err) {
                console.log('err')
                console.log(err)

                // TODO redirection vers la recherche ? TEST
                // navigate(PAGES?.RECHERCHE_PERSONNE)
            } finally {
                setDisablePage(false);
            }
        }

        if (idPersGrc) {

            fetchDetailPersonne().then()
        }

    }, []);

    useEffect(() => {

        const idGrm = keycloakReduce?.decodedToken?.idGrm

        if (idGrm){
            envoiTrace(idGrm,
                CONF?.CODES?.CODES_TRACES?.ACCES_INDIVIDU,
                {
                    prenom: detailPersonne?.prenom,
                })
        }

    }, [])

    useEffect(() => {

        const idGrm = keycloakReduce?.decodedToken?.idGrm
        const departementsPersonne = detailPersonne?.departementsPersonne
        const departementsCorrespondant = infosCorrespondant?.departementsCorrespondant

        if (departementsPersonne?.length > 0
            && departementsCorrespondant?.length > 0) {

            const departementMatch = departementsPersonne.some(val => departementsCorrespondant.includes(val))

            console.log("departementMatch")
            console.log(departementMatch)

            console.log("detailPersonne")
            console.log(detailPersonne)

            if (!departementMatch) {

                const infos = {
                    idGrm: idGrm,
                    nomCorrespondant: infosCorrespondant?.nom,
                    prenomCorrespondant: infosCorrespondant?.prenom,
                    deptsCL: departementsCorrespondant,
                    idGrc: detailPersonne?.idPersGrc,
                    nomAdherent: detailPersonne?.nom,
                    prenomAdherent: detailPersonne?.prenom,
                    numContrat: detailPersonne?.contrat?.[0]?.numeroContrat,
                    deptAdherent: departementsPersonne,
                    // "deptadherent": "<N° de dept de résidence de l'adhérent>"
                    // "deptEtab": "<N° de dept de l'établissement de l'adhérent>"
                }

                envoiTrace(keycloakReduce?.decodedToken?.idGrm,
                    CONF?.CODES?.CODES_TRACES?.HORS_ZONE,
                    infos)

                setHorsZone(true)
            }
        }
    }, [detailPersonne, infosCorrespondant])

    const redirectionFicheContrat = (contrat) => {

        dispatch(updateContrat(contrat))

        navigate(PAGES?.FICHE_CONTRAT)
    }

    const redirectionRemboursements = (contrat) => {

        dispatch(updateContrat(contrat))

        navigate(PAGES?.DEMANDE_INDEMNISATION?.REMBOURSEMENTS)
    }

    return (
        <div className='container-fluid px-5 mt-3'>

            <SecondaryNavBar activePage='fichePersonne' />

            <main id="content" className='mt-3 overlay-container'>

                { disabledPage && <LoadingOverlay classes="upload-overlay"/> }

                <div className="row">

                    <div className="col-lg-6">

                        <div className="card h-100">
                            <section id='informations-personnelles'>
                                <div className="card-header">
                                    <h1>Informations personnelles</h1>
                                </div>

                                <div className="card-body">

                                    {/*{ horsZone && (*/}
                                    {/*    <MessageInfoEnvoi*/}
                                    {/*        isSuccess={ false }*/}
                                    {/*        message={ "Adhérent hors de votre zone de chalandise." }*/}
                                    {/*        display={ true }*/}
                                    {/*    />*/}
                                    {/*) }*/}

                                    <h2>Identité</h2>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <span>
                                                <span className='bold'>Civilité :</span> { detailPersonne?.civilite }
                                            </span>
                                        </div>
                                        <div className="col-md-6">
                                            <span>
                                                <span className='bold'>Nom :</span> { detailPersonne?.nom }
                                            </span>
                                        </div>
                                        <div className="col-md-6">
                                            <span>
                                                <span className='bold'>Prénom :</span> { detailPersonne?.prenom }
                                            </span>
                                        </div>
                                        <div className="col-md-6">
                                            <span>
                                                <span
                                                    className='bold'>Date de naissance :</span> { detailPersonne?.dateNaissance }
                                            </span>
                                        </div>
                                        <div className="col-md-6">
                                            <span>
                                                <span
                                                    className='bold'>Fonction :</span> { detailPersonne?.fonctionPersonne }
                                            </span>
                                        </div>
                                    </div>

                                    <h2 className='mt-3'>Coordonnées</h2>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <span>
                                                <span className='bold'>Email :</span> { detailPersonne?.email }
                                            </span>
                                        </div>
                                        <div className="col-md-6">
                                            <span>
                                                <span
                                                    className='bold'>Téléphone principal :</span> { detailPersonne?.telPrincipal }
                                            </span>
                                        </div>
                                        <div className="col-md-6">
                                            <span>
                                                <span
                                                    className='bold'>Téléphone mobile :</span> { detailPersonne?.telMobile }
                                            </span>
                                        </div>
                                        <div className="col-md-6">
                                            <span>
                                                <span className='bold'>Adresse :</span> { detailPersonne?.adVoie }
                                            </span>
                                        </div>
                                        <div className="col-md-6">
                                            <span>
                                                <span
                                                    className='bold'>Code postal :</span> { detailPersonne?.codePostal }
                                            </span>
                                        </div>
                                        <div className="col-md-6">
                                            <span>
                                                <span className='bold'>Ville :</span> { detailPersonne?.ville }
                                            </span>
                                            <br/>
                                            <a href="#" onClick={ () => navigate("/changement-adresse") }
                                               className='ms-2'>
                                                Changer&nbsp;d'adresse
                                            </a>
                                        </div>
                                    </div>

                                    { !emptyObject(detailPersonne?.etablissement) && (
                                        <>
                                            <h2 className={ 'mt-3' }>Établissement</h2>
                                            <div className="row">
                                                <div className="col-md-6">
                                            <span>
                                                <span
                                                    className='bold'>Nom :</span> { detailPersonne?.etablissement?.nomEtablissement }
                                            </span>
                                                </div>
                                                <div className="col-md-6">
                                            <span>
                                                <span
                                                    className='bold'>Département :</span> { detailPersonne?.etablissement?.departementEtablissement }
                                            </span>
                                                </div>
                                                <div className="col-md-6">
                                            <span>
                                                <span
                                                    className='bold'>Nature gestion :</span> { detailPersonne?.etablissement?.natureGestionEtablissement }
                                            </span>
                                                </div>
                                                <div className="col-md-6">
                                            <span>
                                                <span
                                                    className='bold'>Code :</span> { detailPersonne?.etablissement?.codeEtablissement }
                                            </span>
                                                </div>
                                            </div>
                                        </>
                                    ) }


                                    <h2 className='mt-3'>Informations administratives</h2>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <span>
                                                <span
                                                    className='bold'>Catégorie socio pro :</span> { detailPersonne?.csp }
                                            </span>
                                        </div>
                                        <div className="col-md-6">
                                            <span>
                                                <span
                                                    className='bold'>Type de population :</span> { detailPersonne?.typePopulation }
                                            </span>
                                        </div>
                                        <div className="col-md-6">
                                            <span>
                                                <span
                                                    className='bold'>N° de sécurité sociale :</span> { InfosRegimeObligatoire?.persNir }
                                            </span>
                                        </div>
                                        <div className="col-md-6">
                                            <span>
                                                <span
                                                    className='bold'>Télétransmission  :</span> { InfosRegimeObligatoire?.contTeletransmission }
                                            </span>
                                        </div>
                                        <div className="col-md-6">
                                            <span>
                                                <span
                                                    className='bold'>Centre de gestion :</span> { InfosRegimeObligatoire?.nomCentreGestion }
                                            </span>
                                        </div>
                                        <div className="col-md-6">
                                            <span>
                                                <span
                                                    className='bold'>Code caisse :</span> { InfosRegimeObligatoire?.contCaisse }
                                            </span>
                                        </div>
                                        <div className="col-md-6">
                                            <span>
                                                <span
                                                    className='bold'>Numéro d'agent :</span> { InfosRegimeObligatoire?.numeroAgent }
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>

                    </div>

                    <div className="col-lg-6">

                        <div className="card h-100">
                            <section id='equipements  h-100'>
                                <div className="card-header">
                                    <h1>Équipements</h1>
                                </div>
                                <div className="card-body">

                                    <h2>Liste des contrats</h2>
                                    <div className="row">
                                        { detailPersonne?.contrat?.map(contrat => {

                                            return (
                                                // eslint-disable-next-line react/jsx-key
                                                <div key={ uuidv4() } className='col-md-6 mt-2'>
                                                    <div className="card h-100">
                                                        <div
                                                            className={ `card-header ${ contrat?.dateRadiationContrat
                                                                ? 'header-annule' : contrat?.gammeContrat !== "SANTE"
                                                                    ? "header-rose" : '' }` }
                                                        >
                                                            <h5 aria-level={ 3 }>{ contrat?.familleProduit }</h5>
                                                            { contrat?.dateRadiationContrat &&
                                                                <h6 aria-level={ 4 }>Contrat résilié au
                                                                    : { contrat?.dateRadiationContrat }</h6> }

                                                            <div className='float-end'>
                                                                <span>Gamme : { contrat?.gammeContrat }</span>
                                                            </div>
                                                        </div>
                                                        <div
                                                            className={ `card-body ${ contrat?.dateRadiationContrat ? 'devis-annule' : "" }` }>

                                                            <div className="col-12">
                                                                <span>
                                                                    <span
                                                                        className='bold'>N° de contrat :</span> { contrat?.numeroContrat }
                                                                </span>
                                                            </div>
                                                            <div className="col-12">
                                                                <span>
                                                                    <span
                                                                        className='bold'>Offre :</span> { contrat?.offre }
                                                                </span>
                                                            </div>
                                                            <div className="col-12">
                                                                <span>
                                                                    <span
                                                                        className='bold'>Typologie contrat :</span> { contrat?.typeContrat }
                                                                </span>
                                                            </div>
                                                            <div className="col-12">
                                                                <span>
                                                                    <span
                                                                        className='bold'>Date d'adhésion :</span> { contrat?.dateAdhesionContrat }
                                                                </span>
                                                            </div>
                                                            { contrat?.dateChangementProduit && (
                                                                <div className="col-12">
                                                                    <span>
                                                                        <span
                                                                            className='bold'>Date de changement produit :</span> { contrat?.dateChangementProduit }
                                                                    </span>
                                                                </div>
                                                            ) }
                                                            { contrat?.nomAncienProduit && (
                                                                <div className="col-12">
                                                                    <span>
                                                                        <span
                                                                            className='bold'>Nom ancien produit :</span> { contrat?.nomAncienProduit }
                                                                    </span>
                                                                </div>
                                                            ) }
                                                            <div className="col-12">
                                                                { contrat?.dateRadiationContrat ? (
                                                                    <span>
                                                                        <span
                                                                            className='bold'>Date résiliation :</span> { contrat?.dateRadiationContrat }
                                                                    </span>

                                                                ) : (
                                                                    <span>Pas de résiliation en cours sur ce contrat.</span>
                                                                ) }
                                                            </div>


                                                            <div className="col-12">
                                                                { contrat?.motifResiliationContrat && (
                                                                    <span>
                                                                        <span
                                                                            className='bold'>Date résiliation :</span> { contrat?.motifResiliationContrat }
                                                                    </span>

                                                                ) }
                                                            </div>
                                                            { contrat?.gammeContrat === 'SANTE' && (
                                                                <div className="col-12">
                                                                    <span>
                                                                        <span
                                                                            className='bold'>Prévoyance en inclusion :</span> { contrat?.prevInclusion === "O" ? "oui" : "non" }
                                                                    </span>
                                                                </div>
                                                            )}

                                                            { contrat?.minoration && (
                                                                <div className="col-12">
                                                                    <span>
                                                                        <span
                                                                            className='bold'>Minoration :</span> { getDigit(contrat?.minoration) } %
                                                                    </span>
                                                                </div>
                                                            ) }

                                                        </div>

                                                        <div className="card-footer">

                                                            <div className='d-flex flex-column'>
                                                                { isIndemnisationsAuthorized(contrat?.produit) && (
                                                                    <div className="align-self-end">
                                                                        <button
                                                                            type='button'
                                                                            onClick={ () => redirectionRemboursements(contrat) }
                                                                            className="btn btn-secondary w-auto"
                                                                        >
                                                                            { contrat?.gammeContrat === "SANTE"
                                                                                ? "Consulter les allocations complémentaires"
                                                                                : "Consulter les indémnisations" }
                                                                        </button>
                                                                    </div>
                                                                ) }

                                                                <div className="align-self-end">
                                                                    <button
                                                                        onClick={ () => redirectionFicheContrat(contrat) }
                                                                        type={ 'button' }
                                                                        className="btn btn-primary mt-2">
                                                                        Voir le contrat
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            )
                                        }) }
                                    </div>
                                </div>
                            </section>
                        </div>

                    </div>
                </div>

            </main>
        </div>
    )
}